import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

import {
  CustomValidators,
  ErroMessages,
  IErroMessages,
  TokenService
} from 'viggo-sistemas-core-web';

import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ITipoServicoCorreios } from '@app/modules/tipo_servico_correios/model/tipo_servico_correios.model';
import { TipoServicoCorreioService } from '@app/modules/tipo_servico_correios/services/tipo_servico_correios.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData
} from '@app/shared/components';
import { Utils } from '@app/shared/helpers/utils';
import { ScreenService } from '@app/shared/services';
import { Dialog } from 'primeng/dialog';

@Component({
  templateUrl: './fast-tipo-servico-correio.component.html',
  styleUrls: ['./fast-tipo-servico-correio.component.scss'],
  providers: [TipoServicoCorreioService]
})
export class FastTipoServicoCorreioComponent implements OnInit, AfterViewInit {
  @ViewChild('fastTpServCorreio') fastTpServCorreio: Dialog;
  public form: UntypedFormGroup;

  loading = false;

  displayMessage = {
    codigo: {
      required: 'Código é obrigatório',
      maxlength: 'Deve conter até 5 digitos',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    },
    nome: {
      duplicate: 'Já existe um tipo de serviço com esse nome!',
      required: 'Nome é obrigatório',
      maxlength: 'Não pode ter mais de 60 caracteres',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    },
    qtd_dias: {
      required: 'Qunatidade de dias é obrigatório',
      maxlength: 'Deve conter até 3 digitos',
      isEmptyValue: 'Valor inválido: remova os campos em branco!'
    }
  };

  constructor(
    public screenService: ScreenService,
    public dialogRef: MatDialogRef<FastTipoServicoCorreioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ITipoServicoCorreios,
    protected fb: UntypedFormBuilder,
    public entityService: TipoServicoCorreioService,
    public tokenService: TokenService,
    protected matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router
  ) {}

  ngAfterViewInit(): void {
    if (this.screenService.detectDeviceInfo().isMobile)
      this.fastTpServCorreio.maximize();
  }

  ngOnInit() {
    this.form = this.fb.group({
      codigo: [
        '',
        [
          Validators.required,
          Validators.maxLength(5),
          CustomValidators.isEmptyValue()
        ]
      ],
      nome: [
        '',
        [
          Validators.required,
          Validators.maxLength(60),
          CustomValidators.isEmptyValue()
        ]
      ],
      qtd_dias: [
        0,
        [
          Validators.required,
          Validators.maxLength(3),
          CustomValidators.isEmptyValue()
        ]
      ]
    });
    this.validateForm();
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      const { ...rest } = this.form.value;
      let entity = { domain_id: this.tokenService.getDomain().id, ...rest };
      entity.qtd_dias = Number(entity.qtd_dias);
      entity = Utils.trimAttributes(entity);
      this.entityService.insert(entity).subscribe(
        servico => {
          if (servico) {
            this.matSnackBar.open(
              `Novo tipo de serviço cadastrado com sucesso.`,
              'X',
              {
                duration: 2000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['msg-success']
              }
            );
            this.dialogRef.close(servico);
          }
        },
        (err: HttpErrorResponse) => {
          this.displayError(err);
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    }
  }

  validateOnlyNumbers(event) {
    if (
      !/^\d+$/.test(event.key) &&
      !event.ctrlKey &&
      event.key !== 'Backspace' &&
      event.key !== 'Delete' &&
      event.key !== 'Tab' &&
      event.key !== 'ArrowLeft' &&
      event.key !== 'ArrowRight'
    )
      return false;
  }

  markAllControlsAsDirty() {
    Object.keys(this.form.controls).forEach(controlKey => {
      controlKey = String(controlKey);
      const control = this.form.get(controlKey);
      if (!control || control.valid) return;
      control.markAsDirty();
    });
  }

  validateForm() {
    this.form.markAllAsTouched();
    this.markAllControlsAsDirty();
  }

  actionFnCheckEntityExist(control: AbstractControl) {
    Utils.checkIfValueExist(
      control,
      this.entityService,
      'nome',
      this.tokenService.getDomain().id
    );
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
